/* eslint-disable no-nested-ternary */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated, removeAuthSession } from '../../../services/auth';

function PrvateRoute({ component: Component, layout: Layout, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthenticated() ? (
                    Layout ? (
                        <Layout>
                            <Component {...props} />
                        </Layout>
                    ) : (
                        <Component {...props} />
                    )
                ) : (
                    <>
                        {removeAuthSession()}
                        <Redirect
                            to={{
                                pathname: '/login',
                                state: { from: props.location },
                            }}
                        />
                    </>
                )
            }
        />
    );
}

export default PrvateRoute;
